/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input,
    ContentChildren,
    forwardRef,
    QueryList
} from '@angular/core';


import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';
import { DxiBreakComponent } from './break-dxi';
import { DxiConstantLineComponent } from './constant-line-dxi';
import { DxiStripComponent } from './strip-dxi';



export class DxoArgumentAxisComponent extends NestedOption {
    
    get allowDecimals(): boolean {
        return this._getOption('allowDecimals');
    }
    set allowDecimals(value: boolean) {
        this._setOption('allowDecimals', value);
    }

    
    get argumentType(): string {
        return this._getOption('argumentType');
    }
    set argumentType(value: string) {
        this._setOption('argumentType', value);
    }

    
    get axisDivisionFactor(): number {
        return this._getOption('axisDivisionFactor');
    }
    set axisDivisionFactor(value: number) {
        this._setOption('axisDivisionFactor', value);
    }

    
    get breaks(): Array<DevExpress.viz.ScaleBreak|
        { endValue?: Date|
        number|
        string, startValue?: Date|
        number|
        string }> {
        return this._getOption('breaks');
    }
    set breaks(value: Array<DevExpress.viz.ScaleBreak|
        { endValue?: Date|
        number|
        string, startValue?: Date|
        number|
        string }>) {
        this._setOption('breaks', value);
    }

    
    get breakStyle(): any {
        return this._getOption('breakStyle');
    }
    set breakStyle(value: any) {
        this._setOption('breakStyle', value);
    }

    
    get categories(): Array<number|
        string|
        Date> {
        return this._getOption('categories');
    }
    set categories(value: Array<number|
        string|
        Date>) {
        this._setOption('categories', value);
    }

    
    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    
    get constantLines(): Array<any|
        { color?: string, dashStyle?: string, label?: { font?: DevExpress.viz.Font, horizontalAlignment?: string, position?: string, text?: string, verticalAlignment?: string, visible?: boolean }, paddingLeftRight?: number, paddingTopBottom?: number, value?: Date|
        number|
        string, width?: number }|
        { color?: string, dashStyle?: string, label?: { font?: DevExpress.viz.Font, text?: string, visible?: boolean }, value?: Date|
        number|
        string, width?: number }> {
        return this._getOption('constantLines');
    }
    set constantLines(value: Array<any|
        { color?: string, dashStyle?: string, label?: { font?: DevExpress.viz.Font, horizontalAlignment?: string, position?: string, text?: string, verticalAlignment?: string, visible?: boolean }, paddingLeftRight?: number, paddingTopBottom?: number, value?: Date|
        number|
        string, width?: number }|
        { color?: string, dashStyle?: string, label?: { font?: DevExpress.viz.Font, text?: string, visible?: boolean }, value?: Date|
        number|
        string, width?: number }>) {
        this._setOption('constantLines', value);
    }

    
    get constantLineStyle(): any {
        return this._getOption('constantLineStyle');
    }
    set constantLineStyle(value: any) {
        this._setOption('constantLineStyle', value);
    }

    
    get discreteAxisDivisionMode(): string {
        return this._getOption('discreteAxisDivisionMode');
    }
    set discreteAxisDivisionMode(value: string) {
        this._setOption('discreteAxisDivisionMode', value);
    }

    
    get endOnTick(): boolean {
        return this._getOption('endOnTick');
    }
    set endOnTick(value: boolean) {
        this._setOption('endOnTick', value);
    }

    
    get grid(): any {
        return this._getOption('grid');
    }
    set grid(value: any) {
        this._setOption('grid', value);
    }

    
    get holidays(): Array<Date|
        string|
        number> {
        return this._getOption('holidays');
    }
    set holidays(value: Array<Date|
        string|
        number>) {
        this._setOption('holidays', value);
    }

    
    get hoverMode(): string {
        return this._getOption('hoverMode');
    }
    set hoverMode(value: string) {
        this._setOption('hoverMode', value);
    }

    
    get inverted(): boolean {
        return this._getOption('inverted');
    }
    set inverted(value: boolean) {
        this._setOption('inverted', value);
    }

    
    get label(): any {
        return this._getOption('label');
    }
    set label(value: any) {
        this._setOption('label', value);
    }

    
    get logarithmBase(): number {
        return this._getOption('logarithmBase');
    }
    set logarithmBase(value: number) {
        this._setOption('logarithmBase', value);
    }

    
    get max(): Date|
        number|
        string {
        return this._getOption('max');
    }
    set max(value: Date|
        number|
        string) {
        this._setOption('max', value);
    }

    
    get maxValueMargin(): number {
        return this._getOption('maxValueMargin');
    }
    set maxValueMargin(value: number) {
        this._setOption('maxValueMargin', value);
    }

    
    get min(): Date|
        number|
        string {
        return this._getOption('min');
    }
    set min(value: Date|
        number|
        string) {
        this._setOption('min', value);
    }

    
    get minorGrid(): any {
        return this._getOption('minorGrid');
    }
    set minorGrid(value: any) {
        this._setOption('minorGrid', value);
    }

    
    get minorTick(): any {
        return this._getOption('minorTick');
    }
    set minorTick(value: any) {
        this._setOption('minorTick', value);
    }

    
    get minorTickCount(): number {
        return this._getOption('minorTickCount');
    }
    set minorTickCount(value: number) {
        this._setOption('minorTickCount', value);
    }

    
    get minorTickInterval(): number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number } {
        return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value: number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number }) {
        this._setOption('minorTickInterval', value);
    }

    
    get minValueMargin(): number {
        return this._getOption('minValueMargin');
    }
    set minValueMargin(value: number) {
        this._setOption('minValueMargin', value);
    }

    
    get opacity(): number {
        return this._getOption('opacity');
    }
    set opacity(value: number) {
        this._setOption('opacity', value);
    }

    
    get placeholderSize(): number {
        return this._getOption('placeholderSize');
    }
    set placeholderSize(value: number) {
        this._setOption('placeholderSize', value);
    }

    
    get position(): string {
        return this._getOption('position');
    }
    set position(value: string) {
        this._setOption('position', value);
    }

    
    get setTicksAtUnitBeginning(): boolean {
        return this._getOption('setTicksAtUnitBeginning');
    }
    set setTicksAtUnitBeginning(value: boolean) {
        this._setOption('setTicksAtUnitBeginning', value);
    }

    
    get singleWorkdays(): Array<Date|
        string|
        number> {
        return this._getOption('singleWorkdays');
    }
    set singleWorkdays(value: Array<Date|
        string|
        number>) {
        this._setOption('singleWorkdays', value);
    }

    
    get strips(): Array<any|
        { color?: string, endValue?: Date|
        number|
        string, label?: { font?: DevExpress.viz.Font, horizontalAlignment?: string, text?: string, verticalAlignment?: string }, paddingLeftRight?: number, paddingTopBottom?: number, startValue?: Date|
        number|
        string }|
        { color?: string, endValue?: Date|
        number|
        string, label?: { font?: DevExpress.viz.Font, text?: string }, startValue?: Date|
        number|
        string }> {
        return this._getOption('strips');
    }
    set strips(value: Array<any|
        { color?: string, endValue?: Date|
        number|
        string, label?: { font?: DevExpress.viz.Font, horizontalAlignment?: string, text?: string, verticalAlignment?: string }, paddingLeftRight?: number, paddingTopBottom?: number, startValue?: Date|
        number|
        string }|
        { color?: string, endValue?: Date|
        number|
        string, label?: { font?: DevExpress.viz.Font, text?: string }, startValue?: Date|
        number|
        string }>) {
        this._setOption('strips', value);
    }

    
    get stripStyle(): any {
        return this._getOption('stripStyle');
    }
    set stripStyle(value: any) {
        this._setOption('stripStyle', value);
    }

    
    get tick(): any {
        return this._getOption('tick');
    }
    set tick(value: any) {
        this._setOption('tick', value);
    }

    
    get tickInterval(): number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number } {
        return this._getOption('tickInterval');
    }
    set tickInterval(value: number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number }) {
        this._setOption('tickInterval', value);
    }

    
    get title(): string|
        { font?: DevExpress.viz.Font, margin?: number, text?: string } {
        return this._getOption('title');
    }
    set title(value: string|
        { font?: DevExpress.viz.Font, margin?: number, text?: string }) {
        this._setOption('title', value);
    }

    
    get type(): string {
        return this._getOption('type');
    }
    set type(value: string) {
        this._setOption('type', value);
    }

    
    get valueMarginsEnabled(): boolean {
        return this._getOption('valueMarginsEnabled');
    }
    set valueMarginsEnabled(value: boolean) {
        this._setOption('valueMarginsEnabled', value);
    }

    
    get visible(): boolean {
        return this._getOption('visible');
    }
    set visible(value: boolean) {
        this._setOption('visible', value);
    }

    
    get width(): number {
        return this._getOption('width');
    }
    set width(value: number) {
        this._setOption('width', value);
    }

    
    get workdaysOnly(): boolean {
        return this._getOption('workdaysOnly');
    }
    set workdaysOnly(value: boolean) {
        this._setOption('workdaysOnly', value);
    }

    
    get workWeek(): Array<number> {
        return this._getOption('workWeek');
    }
    set workWeek(value: Array<number>) {
        this._setOption('workWeek', value);
    }

    
    get firstPointOnStartAngle(): boolean {
        return this._getOption('firstPointOnStartAngle');
    }
    set firstPointOnStartAngle(value: boolean) {
        this._setOption('firstPointOnStartAngle', value);
    }

    
    get originValue(): number {
        return this._getOption('originValue');
    }
    set originValue(value: number) {
        this._setOption('originValue', value);
    }

    
    get period(): number {
        return this._getOption('period');
    }
    set period(value: number) {
        this._setOption('period', value);
    }

    
    get startAngle(): number {
        return this._getOption('startAngle');
    }
    set startAngle(value: number) {
        this._setOption('startAngle', value);
    }

    protected get _optionPath() {
        return 'argumentAxis';
    }


    
    get breaksChildren(): QueryList<DxiBreakComponent> {
        return this._getOption('breaks');
    }
    set breaksChildren(value) {
        this.setChildren('breaks', value);
    }

    
    get constantLinesChildren(): QueryList<DxiConstantLineComponent> {
        return this._getOption('constantLines');
    }
    set constantLinesChildren(value) {
        this.setChildren('constantLines', value);
    }

    
    get stripsChildren(): QueryList<DxiStripComponent> {
        return this._getOption('strips');
    }
    set stripsChildren(value) {
        this.setChildren('strips', value);
    }

    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-argument-axis',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'allowDecimals': [{ type: Input },],
'argumentType': [{ type: Input },],
'axisDivisionFactor': [{ type: Input },],
'breaks': [{ type: Input },],
'breakStyle': [{ type: Input },],
'categories': [{ type: Input },],
'color': [{ type: Input },],
'constantLines': [{ type: Input },],
'constantLineStyle': [{ type: Input },],
'discreteAxisDivisionMode': [{ type: Input },],
'endOnTick': [{ type: Input },],
'grid': [{ type: Input },],
'holidays': [{ type: Input },],
'hoverMode': [{ type: Input },],
'inverted': [{ type: Input },],
'label': [{ type: Input },],
'logarithmBase': [{ type: Input },],
'max': [{ type: Input },],
'maxValueMargin': [{ type: Input },],
'min': [{ type: Input },],
'minorGrid': [{ type: Input },],
'minorTick': [{ type: Input },],
'minorTickCount': [{ type: Input },],
'minorTickInterval': [{ type: Input },],
'minValueMargin': [{ type: Input },],
'opacity': [{ type: Input },],
'placeholderSize': [{ type: Input },],
'position': [{ type: Input },],
'setTicksAtUnitBeginning': [{ type: Input },],
'singleWorkdays': [{ type: Input },],
'strips': [{ type: Input },],
'stripStyle': [{ type: Input },],
'tick': [{ type: Input },],
'tickInterval': [{ type: Input },],
'title': [{ type: Input },],
'type': [{ type: Input },],
'valueMarginsEnabled': [{ type: Input },],
'visible': [{ type: Input },],
'width': [{ type: Input },],
'workdaysOnly': [{ type: Input },],
'workWeek': [{ type: Input },],
'firstPointOnStartAngle': [{ type: Input },],
'originValue': [{ type: Input },],
'period': [{ type: Input },],
'startAngle': [{ type: Input },],
'breaksChildren': [{ type: ContentChildren, args: [forwardRef(() => DxiBreakComponent), ] },],
'constantLinesChildren': [{ type: ContentChildren, args: [forwardRef(() => DxiConstantLineComponent), ] },],
'stripsChildren': [{ type: ContentChildren, args: [forwardRef(() => DxiStripComponent), ] },],
};
}


export class DxoArgumentAxisModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoArgumentAxisComponent
  ],
  exports: [
    DxoArgumentAxisComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
